<template>
  <div class="historySms">
    <!-- 搜索表单 -->
    <!-- <SearchFormCollapse slot="search-form">
      <el-form
        ref="searchForm"
        :model="searchForm"
        label-width="140px"
        inline
        label-position="top"
      >
        <el-form-item label="发送对象" prop="smsObjects">
          <el-input
            v-model="searchForm.smsObjects"
            v-trim
            placeholder="请输入发送对象"
            @keypress.enter.native="search"
            maxlength="100"
          />
        </el-form-item>
        <el-form-item label="发送的短信内容" prop="sms">
          <el-input
            v-model="searchForm.sms"
            v-trim
            placeholder="请输入发送的短信内容"
            @keypress.enter.native="search"
            maxlength="100"
          />
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-input
            v-model="searchForm.startTime"
            v-trim
            placeholder="请输入开始时间"
            @keypress.enter.native="search"
            maxlength="100"
          />
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-input
            v-model="searchForm.endTime"
            v-trim
            placeholder="请输入结束时间"
            @keypress.enter.native="search"
            maxlength="100"
          />
        </el-form-item>
        <section>
          <div class="btnBox">
            <el-button type="primary" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
            <el-button @click="reset">重置</el-button>
          </div>
        </section>
      </el-form>
    </SearchFormCollapse> -->

    <el-divider content-position="right">
      <span>标签数量&emsp;:&emsp;{{ rowData.copies }}&emsp;</span>
      <!-- <el-divider direction="vertical"></el-divider>
      <span>物资数量&emsp;:&emsp;{{ rowData.num }}</span> -->
    </el-divider>
    <span style="float: right"></span>
    <PublicTable
      ref="dialogTable"
      :data-source="dataSource"
      @sizeChange="changeSize"
      @currentChange="changeNum"
      @handleSelection="publicTableHandleSelectionChange"
    >
      <template #dddw="{ scope }">
          {{ scope.dddw }}
        </template>
        <!-- <template #num="{ scope }">
          <el-input-number
            v-model="scope.num"
            :min="0"
            :disabled="isGlobal"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template> -->
        <template #remarks="{ scope }">
        <el-input v-model="scope.remarks" placeholder="请输入备注" maxlength="150" v-trim></el-input>
      </template>
      <template #copies="{ scope }">
          <el-input-number
            v-model="scope.copies"
            :min="1"
            :max="20"
           :disabled="true"
          ></el-input-number>
        </template>
        <!-- 连云港 -->
        <template #storageLocationProject="{ scope }">
          <el-input
            v-model="scope.storageLocationProject"
            placeholder="请输入库位"
            maxlength="150"
            v-trim
          ></el-input>
        </template>
        <template #materialsNum="{ scope }">
          <el-input-number
            v-model="scope.materialsNum"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
        <!-- 融合 -->
        <template #createTime="{ scope }">
          <el-date-picker
            style="width: 100%"
            v-model="scope.createTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            type="datetime"
            placeholder="请选择入库日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </template>
        <template #htsl="{ scope }">
          <el-input-number
            v-model="scope.htsl"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
        
        <template #stock="{ scope }">
          <el-input v-model="scope.stock" placeholder="请输入托盘号" maxlength="150" v-trim></el-input>
        </template>
        <template #shippingSpace="{ scope }">
          <el-input v-model="scope.shippingSpace" placeholder="请输入仓位号" maxlength="150" v-trim></el-input>
        </template>
        <template #factoryCode="{ scope }">
          <el-input v-model="scope.factoryCode" placeholder="请输入出厂编码" maxlength="150" v-trim></el-input>
        </template>
        <template #date="{ scope }">
          <el-date-picker
          style="width: 100%"
          v-model="scope.date"
          value-format="yyyy-MM-dd"
          align="right"
          type="date"
          placeholder="请选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        </template>
        <template #numberDisks="{ scope }">
          <el-input-number
            v-model="scope.numberDisks"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
        <template #quantityIssued="{ scope }">
          <el-input-number
            v-model="scope.quantityIssued"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
        <template #balanceQuantity="{ scope }">
          <el-input-number
            v-model="scope.balanceQuantity"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
    </PublicTable>
  </div>
</template>
<script>
// import { getHistorySmsApi } from "@/api/synchronous_data";
import cols from "./customizationModel";
import { mapState } from "vuex";
import {
  getListFiledApi,
} from "@/api/synchronous_data";
import SearchFormCollapse from "@/components/common/SearchFormCollapse";
export default {
  components: {
    SearchFormCollapse,
  },
  props: {
    rowData: {
      type: Object,
      default: () => {},
    },
    colsData:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      pickerOptions: {
        // disabledDate(time) {
        //   return new Date().getFullYear() < time.getFullYear()||new Date().getFullYear() > time.getFullYear();
        //   // return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      // 搜索
      searchForm: {
        createTime: "",
        createUser: 0,
        deleted: 0,
        description: "",
        deviceid: "",
        id: 0,
        internalStatus: "",
        sms: "",
        smsObjects: "",
        status: "",
        tenantid: "",
        updateTime: "",
        updateUser: 0,
      },
      dataSource: {
        topButtons: [
          //  {
          //    name: '添加群组项', //按钮名称
          //    key: 1,  // 唯一标识符
          //   //  permission: 2010106, // 权限点
          //   //  type: '',  // 使用element自带按钮类型
          //    bgColor: 'skyblue', // 自定义背景色
          //    handleClick: this.handleEdit, //自定义事件
          //    disabled:false,//是否禁用
          //    loading:false,//是否加载中状态
          //  },
        ],
        data: [], // 表格数据
        cols:[], // 表格的列数据
        publicTableHandleSelectionChange: (val) => {}, // 点击行选中多选返回选中数组
        isSelection: false, // 表格有多选时设置
        isMultipleChoice: false, // 是否单选
        isReserve: false, // 是否分页多选
        isOperation: false, // 表格有操作列时设置
        isIndex: true, // 列表序号
        loading: false, // loading
        pageData: {
          total: 0, // 总条数
          pageSize: 10, // 每页数量
          pageNum: 1, // 页码
          pageSizes: [10, 20, 30, 40], // 每页数量
        },
        operation: {
          // 表格有操作列时设置
          label: "操作", // 列名
          width: "150", // 根据实际情况给宽度
          data: [
            // {
            //   label: "冻结", // 操作名称
            //   // permission:'', //权限点
            //   type: "info", //按钮类型
            //   handleRow: function () {}, // 自定义事件
            // },
            // {
            //   label: "手动匹配",
            //   type: "button",
            //   handleRow: this.handleClickPoiner,
            //   icon:'el-icon-thumb',
            //   style:'primary'
            // },
          ],
        },
      },
      pageReqParams: {
        page: 1,
        capacity: 10,
        model: {},
        sorts: null,
      },
      apiData:[],
    };
  },
  // computed: {
  //   ...mapState(["templateObj"]),
  // },
  // watch: {
  //   templateObj: {
  //     handler(newVal) {
  //       this.dataSource.loading = true;
  //       getListFiledApi({
  //         templateKey: newVal.templateKey,
  //         key: "1",
  //       }).then(res=>{
  //         this.dataSource.cols=res||[];
  //       })
  //       .finally(()=>{
  //         this.dataSource.loading = false;
  //       })
  //     },
  //     immediate:true
  //   },
  // },
  methods: {
    //时间转换
    getSTimeStart(val) {
      this.searchForm.scheduledStartTime = val;
    },
    //时间转换
    getSTimeEnd(val) {
      this.searchForm.scheduledEndTime = val;
    },
    search() {
      this.pageReqParams.model = this.searchForm;
      this.newPage();
    },
    reset() {
      for (let key in this.searchForm) {
        this.searchForm[key] = "";
      }
      this.pageReqParams.model = this.searchForm;
      this.newPage();
    },
    // 详情表格选中数据
    publicTableHandleSelectionChange(val) {
      this.checkedSelectArr = val;
    },
    // 改变每页查询数量
    changeSize(size) {
      this.pageReqParams.page = this.dataSource.pageData.pageNum = 1;
      this.pageReqParams.capacity = this.dataSource.pageData.pageSize = size;
      this.newPage();
    },
    // 分页页码
    changeNum(pageNum) {
      this.pageReqParams.page = this.dataSource.pageData.pageNum = pageNum;
      this.newPage();
    },
    // 请求dialog列表项
    newPage() {
      this.dataSource.loading = true;
      setTimeout(() => {
        this.dataSource.cols=this.colsData;
        this.dataSource.data = this.apiData.slice((this.pageReqParams.page-1)*this.pageReqParams.capacity,this.pageReqParams.capacity*this.pageReqParams.page)
        this.dataSource.pageData.total = this.apiData.length;
        this.dataSource.loading = false;
      }, 10);
    },
  },
  async created() {
    let arr = [];
    for (let i = 0; i < this.rowData.copies; i++) {
      arr.push({ ...this.rowData, copies: 1,num:0, id: i+1 });
    }
    this.apiData = arr;
   await this.newPage();
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/style/variables.scss";
.btnBox {
  line-height: 114px;
}
</style>
